import { array, object, string } from 'yup'
import { t } from 'ttag'

import { ASSESSMENT_GROUP_FIELD, COMMENT_FIELD, SCORE_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [ASSESSMENT_GROUP_FIELD]: array().of(
      object().shape({
        [COMMENT_FIELD]: string().optional(),
        [SCORE_FIELD]: string().required(t`This field cannot be empty.`),
      }),
    ),
  })
